<template>
<v-menu ref="menu" :close-on-content-click="false" :return-value.sync="month" transition="scale-transition" offset-y min-width="290px">
    <template v-slot:activator="{ on }">
        <v-text-field v-model="month" width="100" class="mx-auto" v-bind="$attrs"
            prepend-inner-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly v-on="on"
            hide-details></v-text-field>
    </template>
    <v-date-picker v-model="month" no-title scrollable type="month" @input="$refs.menu.save(month); $emit('input', month)"></v-date-picker>
</v-menu>
</template>
<script>
export default {
    props: ["value"],
    data(){
        return {
            month: this.$props.value
        }
    },
    watch: {
        value(){
            this.month = this.value;
        }
    }
}
</script>